<template>
  <div>
    <b-dropdown id="dropdown-1" :text="text" class="my-md-2 company-picker ui-dashboard-menu-dropdown" variant="company-picker">
      <b-dropdown-item v-for="a_company in profile_companies" :key="a_company[0].id" :active="a_company[0].id==company_id" @click="redirect(a_company[0].id)">{{a_company[0].name}}</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <div v-if="accounting_clients.length > 0">
        <b-dropdown-item v-for="a_company in accounting_clients" :key="a_company[0].id" :active="a_company[0].id==company_id" @click="redirect(a_company[0].id)">{{a_company[0].name}}</b-dropdown-item>
      </div>
      <div v-else>
        <b-dropdown-item @click="addCompany()">
          <font-awesome-icon icon="fa-solid fa-plus" /><span v-translate>Add company profile</span></b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>
<script>
import CompanyService from "@/store/services/company.service.js";

export default {
  name: "CompanyPicker",
  components: {},
  data() {
    return {
      company_id: '',
      profile_companies: [],
      accounting_clients: [],
      text: '',
    }
  },
  created(){
    this.company_id = window.company_id
    CompanyService.companyPickerOptions().then(function (response) {
      this.profile_companies = response.data['profile_companies']
      this.accounting_clients = response.data['accounting_clients']
      const currentCompany = this.profile_companies.find(company => company[0].id === this.company_id)
      this.text = currentCompany[0]['name']
    }.bind(this))
  },
  methods: {
    redirect(target_company){
      var redirect_url = this.$router.currentRoute.path;
      var url = window.Urls['accounts_switch_profile_company'](target_company);
      url = url + "?next=" + redirect_url;
      window.location.href = url;
    },
    addCompany(){
      var url = window.Urls["accounts_add_company"]() + "?next=" + this.$router.currentRoute.path;
      window.location.href = url;
    }
  }
};
</script>
<style lang="scss">

.company-picker {
  .btn-company-picker {
    color: #eb8d36;
    box-shadow: none !important;
    border: none !important;
    background: none !important;
    padding-left: 0 !important;
  }
  .dropdown-menu {
    li {
      .dropdown-item.active { 
        color: $colorTextBase;
        background-color: transparent; 
      }
    }
  }
}

</style>